import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePut} from "../../hooks/http";


const Details = ({id}) => {
    const [entity, setEntity] = useState(null)
    const [isLoading, setIsLoading] = useState(true)


    const GetEntity = async () => {
        const LogRequest = await UsePut(
            `/logs/get`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        if(LogRequest?.entities?.length > 0){
            return LogRequest.entities[0]
        }

        return null;
    }


    useEffect(() => {
        GetEntity().then((response) => {
            setEntity(response)
            setIsLoading(false)
        })
    }, [])






    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            {!isLoading && <div>
                                <strong>{entity.title}</strong>
                                <p>{entity.description}</p>
                            </div>}
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Details